import clsx from 'clsx';
import React from 'react';

import { topic_landing_path } from '../../../routes';
import styles from './styles.module.css';

export type EntityTopic = {
  entity_type: string;
  id: number;
  name: string;
};

export default function EntityTopics({ topics }: { topics?: EntityTopic[] }) {
  return (
    <div className={styles.topics}>
      {topics.map((topic) => (
        <a
          href={topic_landing_path(topic.name)}
          className={clsx('track-link', styles.topic)}
          data-name={topic.name}
          data-type={topic.entity_type}
          key={topic.id}
        >
          {topic.name}
        </a>
      ))}
    </div>
  );
}
